import React from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './SpotifyAuthRequest.css'

export default function SpotifyAuthRequest(props){
    return (
        <Container className="d-flex align-items-center justify-content-center text-white">
          <Row className="text-center">
            <Col>
              <Alert variant="success">
                <Alert.Heading>Spotify Authorization Required</Alert.Heading>
                <p>Since I have not been able to register this app with spotify, it is only avalible locally :(</p>
                <hr />
                {/* <Button variant="success" size="lg" onClick={() => props.spotifyEnpoint()}>
                  Authorize Spotify
                </Button> */}
              </Alert>
            </Col>
          </Row>
        </Container>
      );
}